import { render, staticRenderFns } from "./HMSUpdateStatusTask.vue?vue&type=template&id=72b611a3&scoped=true&"
import script from "./HMSUpdateStatusTask.vue?vue&type=script&lang=js&"
export * from "./HMSUpdateStatusTask.vue?vue&type=script&lang=js&"
import style0 from "./HMSUpdateStatusTask.vue?vue&type=style&index=0&id=72b611a3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b611a3",
  null
  
)

export default component.exports